import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import stockService from '../../services/stockService';
import { StockItem, TypeStock } from '../../types';

interface StockState {
  list: StockItem[];
  loading: boolean;
  error: string | null;
}

const initialState: StockState = { list: [], loading: false, error: null };

export const fetchStock = createAsyncThunk('stock/fetchAll', (type?: TypeStock) =>
  stockService.getAll(type)
);

export const createStockItem = createAsyncThunk('stock/create', (data: Omit<StockItem, 'id'>) =>
  stockService.create(data)
);

export const updateStockItem = createAsyncThunk(
  'stock/update',
  ({ id, data }: { id: number; data: Partial<Omit<StockItem, 'id'>> }) =>
    stockService.update(id, data)
);

export const deleteStockItem = createAsyncThunk('stock/delete', async (id: number) => {
  await stockService.delete(id);
  return id;
});

const stockSlice = createSlice({
  name: 'stock',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStock.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchStock.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchStock.rejected, (state, action) => { state.loading = false; state.error = action.error.message ?? 'Erreur'; })
      .addCase(createStockItem.fulfilled, (state, action) => { state.list.unshift(action.payload); })
      .addCase(updateStockItem.fulfilled, (state, action) => {
        const idx = state.list.findIndex((i) => i.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteStockItem.fulfilled, (state, action) => {
        state.list = state.list.filter((i) => i.id !== action.payload);
      });
  },
});

export default stockSlice.reducer;
